// extracted by mini-css-extract-plugin
module.exports = {"standard":"_3ea6fa5da8--standard--m1YK3","light":"_3ea6fa5da8--light--jrmpC","outline":"_3ea6fa5da8--outline--TmOr2"};